/**
 * Firebase Configuration for OilWellX
 * Replace these values with your Firebase project credentials
 */

import { Capacitor } from '@capacitor/core';

// Detect if running on Android native
const isAndroid = Capacitor.getPlatform() === 'android';

// Use Web API key for all platforms when using JS SDK
// The JS SDK in Capacitor runs in a WebView and behaves like a web client.
// Using the Android-specific API key (restricted to package name/SHA-1) often fails
// with "network error" because the WebView origin doesn't match the native app restriction.
const getApiKey = () => {
  return import.meta.env.VITE_FIREBASE_API_KEY || "YOUR_API_KEY";
};

// Use Web App ID for all platforms when using JS SDK
const getAppId = () => {
  return import.meta.env.VITE_FIREBASE_APP_ID || "YOUR_APP_ID";
};

export const firebaseConfig = {
  apiKey: getApiKey(),
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "YOUR_PROJECT_ID.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "YOUR_PROJECT_ID.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "YOUR_SENDER_ID",
  appId: getAppId(),
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "YOUR_MEASUREMENT_ID"
};

// Emulator settings for local development (optional)
export const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';
export const emulatorConfig = {
  auth: { host: 'localhost', port: 9099 },
  firestore: { host: 'localhost', port: 8080 },
  storage: { host: 'localhost', port: 9199 },
  functions: { host: 'localhost', port: 5001 }
};
